import { configureStore } from '@reduxjs/toolkit';
import AuthReducer from "../redux/slice/authSlice";
import PropertyReducer from "../redux/slice/propertySlice";
import inquiryReducer from "../redux/slice/inquirySlice";

const store = configureStore({
    reducer:{
      auth:AuthReducer,
      property:PropertyReducer,
      inquiry:inquiryReducer
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: false,
        }),
});

export default store;